/**
 * Take a base64 encoded JWT token and return its content.
 * If the token is ill-formed, return null.
 * @param {string} token 
 * @returns 
 */
export function parseJwt(token) {
  if (!token) {
    return null;
  }
  let base64Url = token.split(".")[1];
  if (!base64Url) {
    return null;
  }
  let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  let jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(function (c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}


export function isJwtExpired(token) {
  const expiry = (JSON.parse(atob(token.split('.')[1]))).exp;
  return (Math.floor((new Date()).getTime() / 1000)) >= expiry;
}